// extracted by mini-css-extract-plugin
export default {"title":"ItemActionPanel_title__2b4U5","icon":"ItemActionPanel_icon__FTQK6","wrapper":"ItemActionPanel_wrapper__gOkCd","bc":"ItemActionPanel_bc__Er3FC"};